import { Button, Modal, Form, Row, Col } from "react-bootstrap";
import { Dispatch, SetStateAction, useState } from "react";
import { authServices } from "Utils/auth/services";
import snackbarUtil from "Utils/snackBarUtil";

interface PermissionModalProps {
  show: any;
  userIds: string;
  userName: string;
  getUserList: () => Promise<void>;
  setShowRemoveAuth: Dispatch<SetStateAction<boolean>>;
}

const RemoveAuth = ({
  show,
  userName,
  getUserList,
  setShowRemoveAuth,
  userIds,
}: PermissionModalProps) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [passVal, setPasswordVal] = useState<string>("");
  const [errors, setErrors] = useState<{ password?: string }>({});

  const validateForm = () => {
    let formErrors: { password?: string } = {};
    if (!passVal || passVal.trim().length < 6) {
      formErrors.password = "Password must be at least 6 characters.";
    }
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const getEnabledTelegram = async (password: string) => {
    const { response } = await authServices.getRemoveAuth({
      user_id: userIds,
      pass_type: "PASSWORD",
      password,
    });
    if (response?.status) {
      snackbarUtil.success(response?.msg);
      setShowRemoveAuth(false);
      await getUserList();
    } else {
      snackbarUtil.error(response?.msg || "Something went wrong.");
    }
  };

  const handleSubmit = () => {
    if (!validateForm()) return;
    getEnabledTelegram(passVal);
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        setShowRemoveAuth(false);
        setPasswordVal("");
      }}
      className="zoomIn"
      scrollable
    >
      <Modal.Header className="modal-title fw-bold d-flex justify-content-between pb-1">
        <span>Remove Authentication of {userName}</span>
        <Button
          variant="light btn-sm"
          onClick={() => {
            setShowRemoveAuth(false);
            setPasswordVal("");
          }}
        >
          <i className="ri-close-line fs-xl align-middle"></i>
        </Button>
      </Modal.Header>

      <Modal.Body className="fs-md">
        <Row className="gap-3">
          <Col sm={12}>
            <Form.Group controlId="formPassword">
              <Form.Label>Enter Password</Form.Label>
              <div className="position-relative">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  value={passVal}
                  onChange={(e) => setPasswordVal(e.target.value)}
                  isInvalid={!!errors.password}
                />
                <Button
                  variant="link"
                  className="position-absolute end-0 top-0 bottom-0 text-decoration-none text-muted password-addon"
                  type="button"
                  id="password-addon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i
                    className={`${
                      showPassword ? "ri-eye-fill" : "ri-eye-off-fill"
                    } align-middle`}
                  ></i>
                </Button>
                <Form.Control.Feedback type="invalid">
                  {errors.password}
                </Form.Control.Feedback>
              </div>
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer className="border-top">
        <Button
          variant="light"
          onClick={() => {
            setShowRemoveAuth(false);
            setPasswordVal("");
          }}
        >
          Cancel
        </Button>
        <Button variant="success" onClick={handleSubmit}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveAuth;
